import axios from "axios";
import { stage_url } from "../api-urls";
import Headers from "./Headers";

export async function GetHsn(payload) {
    return await axios.get(
        `${stage_url}/api-business-v3/v1/query/hsn/map`,
        {
            params: payload, 
            headers: Headers.getHeaders(true),
        }
    );
}

export async function addEditHsn(payload) {
    return await axios.post(
        `${stage_url}/api-business-v3/v1/query/hsn/map/add-update`, payload,
        {
            headers: Headers.getDukanHeaders(true),
        }
    );
}
